import React, { useCallback } from "react";
import { useUILocale } from "../../UILocale";
import { ConfirmDialog } from "../ConfirmDialog";
import { useDialog } from "../useDialog";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  DialogContentText,
} from "@mui/material";
import { getErrorDetails } from "./getErrorDetails";

export const useNetworkErrorDialog = () => {
  const {
    dialog: {
      networkError: { headline, body, confirmButton, showDetails },
    },
  } = useUILocale();
  const { dialogProps, openDialog } = useDialog();
  const [error, setError] = React.useState<unknown>(null);
  const openNetworkErrorDialog = useCallback(
    (error: unknown) => {
      setError(error);
      openDialog();
    },
    [openDialog],
  );
  const dialog = (
    <ConfirmDialog
      id="network-error-dialog"
      headline={headline}
      {...dialogProps}
      useSingleAction
      confirmButtonText={confirmButton}
      onConfirm={() => window.location.reload()}
    >
      <DialogContentText>{body}</DialogContentText>
      <Accordion sx={{ mt: 2 }}>
        <AccordionSummary>{showDetails}</AccordionSummary>
        <AccordionDetails>{getErrorDetails(error)}</AccordionDetails>
      </Accordion>
    </ConfirmDialog>
  );
  return { networkErrorDialog: dialog, openNetworkErrorDialog };
};
